import type { State } from './types.tsx';

export const initialState: State = {};
